export default "__VITE_ASSET__BKG7$XSY__"